import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref) {
  var smallerThan = _ref.smallerThan,
    largerThan = _ref.largerThan,
    query = _ref.query,
    styles = _ref.styles;
  var media = {};
  var minWidth = theme.fn.size({
    size: largerThan,
    sizes: theme.breakpoints
  }) + 1;
  var maxWidth = theme.fn.size({
    size: smallerThan,
    sizes: theme.breakpoints
  });
  if (largerThan !== void 0 && smallerThan !== void 0) {
    media["@media (min-width: ".concat(minWidth, "px) and (max-width: ").concat(maxWidth, "px)")] = styles;
  } else {
    if (largerThan !== void 0) {
      media["@media (min-width: ".concat(theme.fn.size({
        size: largerThan,
        sizes: theme.breakpoints
      }) + 1, "px)")] = styles;
    }
    if (smallerThan !== void 0) {
      media["@media (max-width: ".concat(theme.fn.size({
        size: smallerThan,
        sizes: theme.breakpoints
      }), "px)")] = styles;
    }
  }
  if (query) {
    media["@media ".concat(query)] = styles;
  }
  return {
    media: media
  };
});
export default useStyles;